module.exports = __webpack_public_path__ + "static/hero-bottom-land-d17441e1a2ead34019b30e02afa4a91a.svg";